export const SET_ZIP_STATE_VERIFIED = 'SET_ZIP_STATE_VERIFIED';

export const setZipStateVerified = (isVerified: boolean) => ({
  type: SET_ZIP_STATE_VERIFIED,
  data: isVerified,
});
